<template>
  <div>
    <top-bar/>
    <div class="content mt-5">
      <div class="container">
        <div class="row justify-content-center align-items-center">
          <div class="col-md-6">
            <auth-login-form
              title="Adicionar conta"
              subtitle="Informe seu usuário de acesso"
              submit-label="Continuar"
              :show-unknown-user-link="false"
              :show-recover-link="false"
              :allow-recovery-redirect="false"
              :can-submit="empresas.length < 3"
              blocked-message="No momento é possível adicionar no máximo 3 contas."
              card-style="max-width: 420px"
              @authenticated="handleAuthenticated"
            />
            <div class="text-center mt-3">
              <router-link to="/configs" class="text-decoration-none">Voltar para Configs</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthLoginForm from '@/components/auth/AuthLoginForm.vue'
import TopBar from '@/components/commons/TopBar.vue'

export default {
  name: 'Empresas',
  components: { TopBar, AuthLoginForm },
  data() {
    return {
      token: ""
    }
  },
  methods: {
    async handleAuthenticated({ data, email }) {
      const key = data.token;

      if (this.empresas.find(e => e.key === key || String(e.id_empresa) === String(data.id_empresa))) {
        this.$swal('Esta empresa já está conectada. Use Adicionar WhatsApp nas configurações para conectar outro número.');
        return;
      }

      if (!await this.$store.dispatch('addConta', { ...data, email })) return;
      if (this.isElectron) {
        this.$router.push('/configs');
        this.$swal({
          text: 'Conexão adicionada. Deseja reiniciar o aplicativo agora para ativá-la?',
          buttons: ['Mais tarde', 'Reiniciar agora']
        }).then(reiniciar => {
          if (reiniciar) window.control.fechar({ reiniciar: true });
        });
      } else {
        window.location.href = '/configs';
      }
    }
  },

  computed: {
    empresas() {
      return this.$store.state.empresas;
    }
  },

  created() {
    this.token = localStorage.getItem('token');
  }
}
</script>
<style scoped>
</style>
